import React from 'react';
import TextBlockFooterView from './text-block-footer-view';

const TextBlockFooterContainer = ({
  title,
  text,
  onTitleChange,
  onTextChange,
}) => {
  return (
    <TextBlockFooterView
      title={title}
      text={text}
      onTitleChange={onTitleChange}
      onTextChange={onTextChange}
    />
  );
};

export default TextBlockFooterContainer;


